export default __webpack_public_path__ + "static/media/slider6.0b2b382d.jpeg";